"use strict";
exports.__esModule = true;
var CustomValidators = /** @class */ (function () {
    function CustomValidators() {
    }
    CustomValidators.oneDigitOrSpecialChar = function (control) {
        if (CustomValidators.oneDigit(control) !== null && CustomValidators.oneSpecialChar(control) !== null) {
            return { oneDigitOrSpecialChar: true };
        }
        return null;
    };
    CustomValidators.oneDigit = function (control) {
        var regex = /\d/;
        var isValid = regex.test(control.value);
        if (control.value.length > 0) {
            return isValid ? null : { oneDigit: true };
        }
        return null;
    };
    CustomValidators.oneUppercase = function (control) {
        var regex = /[A-Z]/;
        var isValid = regex.test(control.value);
        if (control.value.length > 0) {
            return isValid ? null : { oneUppercase: true };
        }
        return null;
    };
    CustomValidators.oneSpecialChar = function (control) {
        var regex = /[^a-zA-Z0-9]/;
        var isValid = regex.test(control.value);
        if (control.value.length > 0) {
            return isValid ? null : { oneSpecialChar: true };
        }
        return null;
    };
    CustomValidators.passwordMatch = function (form) {
        var pw1 = form.get('newPassword');
        var pw2 = form.get('confirmPassword');
        if (pw1 != null && pw2 != null && pw1.value !== pw2.value) {
            return { passwordMatch: true };
        }
        return null;
    };
    return CustomValidators;
}());
exports.CustomValidators = CustomValidators;
